document.addEventListener("DOMContentLoaded", function () {
  function normalize(value) {
    return String(value || "").trim().toLowerCase();
  }

  function eqCI(a, b) {
    return normalize(a) === normalize(b);
  }

  function escapeHTML(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  /* =================
     GALLERY SWAP
  ================= */
  const thumbnails = Array.from(document.querySelectorAll(".thumbnail"));
  const mainBanner = document.getElementById("main-banner");

  function swapMainSrc(newSrc) {
    if (!mainBanner || !newSrc) return;

    mainBanner.classList.add("fade-in");

    const img = new Image();
    img.onload = () => {
      mainBanner.src = newSrc;
      mainBanner.srcset = newSrc;
      requestAnimationFrame(() => mainBanner.classList.remove("fade-in"));
    };
    img.onerror = () => mainBanner.classList.remove("fade-in");
    img.src = newSrc;
  }

  thumbnails.forEach((thumb) => {
    thumb.addEventListener("click", function () {
      thumbnails.forEach((t) => t.classList.remove("selected"));
      this.classList.add("selected");
      swapMainSrc(this.dataset.large || this.src);
    });
  });

  /* =================
     MOBILE SWIPE
  ================= */
  (function () {
    if (!mainBanner || !thumbnails.length) return;

    let currentIndex = thumbnails.findIndex((el) => el.classList.contains("selected"));
    if (currentIndex < 0) currentIndex = 0;

    let startX = 0;
    let startY = 0;
    let swiping = false;

    function goTo(idx) {
      currentIndex = (idx + thumbnails.length) % thumbnails.length;
      thumbnails.forEach((x) => x.classList.remove("selected"));
      const t = thumbnails[currentIndex];
      t.classList.add("selected");
      swapMainSrc(t.dataset.large || t.src);
    }

    mainBanner.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });

    mainBanner.addEventListener("touchend", (e) => {
      if (!swiping) return;
      swiping = false;

      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;

      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) goTo(currentIndex + 1);
        else goTo(currentIndex - 1);
      }
    });
  })();

  /* =================
     PRODUCT FORM
  ================= */
  const form = document.querySelector("form[id^='product-form-']");
  if (!form) return;

  const hiddenInput = form.querySelector("input[name='id']");
  const addToCartBtn = document.querySelector("button[id^='add-to-cart-']");
  const addToCartWrap = addToCartBtn?.closest(".add-to-cart-wrapper");
  const hintEl = document.querySelector("p[id^='selection-hint-']");
  const priceEls = document.querySelectorAll(".sticky-cart-price");

  if (hintEl) {
    hintEl.dataset.defaultText = hintEl.textContent.trim();
  }

  if (hintEl && addToCartWrap && hintEl.parentElement !== addToCartWrap) {
    addToCartWrap.prepend(hintEl);
  }

  const variants = Array.isArray(window.productVariants) ? window.productVariants : [];
  const initialPriceHTML = priceEls[0] ? priceEls[0].innerHTML : "";

  const groups = Array.from(form.querySelectorAll("[data-option-group-frame]"))
    .map((frame) => {
      const key = frame.dataset.optionGroupFrame || "";
      const index = Number(frame.dataset.optionIndex);

      return {
        key,
        index,
        buttons: Array.from(frame.querySelectorAll(`.option-btn[data-option-group="${key}"]`)),
        previewEl: document.getElementById(`${key}-preview`)
      };
    })
    .filter((group) => {
      return group.key && Number.isInteger(group.index) && group.index >= 0 && group.buttons.length;
    });

  function setPriceHTML(variant) {
    if (!variant) {
      priceEls.forEach((el) => {
        el.innerHTML = initialPriceHTML;
      });
      return;
    }

    priceEls.forEach((el) => {
      if (
        variant.formatted_compare_at_price &&
        Number(variant.compare_at_price) > Number(variant.price)
      ) {
        el.innerHTML = `
          <span class="price--compare"><s>${variant.formatted_compare_at_price}</s></span>
          <span class="price--sale">${variant.formatted_price}</span>
        `;
      } else {
        el.innerHTML = variant.formatted_price || initialPriceHTML;
      }
    });
  }

  function setCartVisibility(showButton, hintText = "", hintState = "") {
    if (addToCartBtn) {
      addToCartBtn.style.visibility = showButton ? "visible" : "hidden";
      addToCartBtn.style.pointerEvents = showButton ? "auto" : "none";
    }

    if (hintEl) {
      hintEl.style.display = showButton ? "none" : "block";
      hintEl.textContent = hintText || hintEl.dataset.defaultText || "";
      hintEl.classList.remove("ready", "warning");

      if (hintState) {
        hintEl.classList.add(hintState);
      }
    }
  }

  function getSelectedValue(group) {
    const activeBtn = group.buttons.find((btn) => btn.classList.contains("active"));
    return activeBtn ? activeBtn.dataset.value || "" : "";
  }

  function getSelectedButton(group) {
    return group.buttons.find((btn) => btn.classList.contains("active")) || null;
  }

  function getSelectedState() {
    const state = {};
    groups.forEach((group) => {
      state[group.key] = getSelectedValue(group);
    });
    return state;
  }

  function selectionIsComplete(state) {
    return groups.every((group) => !!state[group.key]);
  }

  function variantMatchesState(variant, state, requireComplete) {
    return groups.every((group) => {
      const selectedValue = state[group.key];
      if (!selectedValue) return !requireComplete;
      return eqCI(variant.options?.[group.index], selectedValue);
    });
  }

  function findMatchingVariant(state, requireAvailable = false, requireComplete = false) {
    return variants.find((variant) => {
      if (requireAvailable && !variant.available) return false;
      return variantMatchesState(variant, state, requireComplete);
    });
  }

  function getPreviewAlt(selectedButton) {
    return selectedButton?.dataset.previewAlt || window.themeStrings?.variant_preview_alt || "";
  }

  function renderPreviewImage(previewEl, src, altText) {
    if (!previewEl || !src) {
      if (previewEl) previewEl.innerHTML = "";
      return;
    }

    previewEl.innerHTML = `
      <img
        src="${escapeHTML(src)}"
        width="280"
        height="280"
        loading="lazy"
        alt="${escapeHTML(altText)}"
      >
    `;
  }

  function renderPreview(group, state) {
    if (!group.previewEl) return;

    const selectedValue = state[group.key];
    const selectedButton = getSelectedButton(group);

    if (!selectedValue || !selectedButton) {
      group.previewEl.innerHTML = "";
      return;
    }

    const altText = getPreviewAlt(selectedButton);

    if (group.key === "color") {
      const variant = findMatchingVariant(
        { ...state, color: selectedValue },
        false,
        false
      );

      renderPreviewImage(group.previewEl, variant?.featured_image || "", altText);
      return;
    }

    const previewSrc = selectedButton.dataset.preview || "";
    renderPreviewImage(group.previewEl, previewSrc, altText);
  }

  function updateButtonAvailability() {
    const currentState = getSelectedState();

    groups.forEach((group) => {
      group.buttons.forEach((btn) => {
        const testState = {
          ...currentState,
          [group.key]: btn.dataset.value || ""
        };

        const matchingAvailableVariant = findMatchingVariant(testState, true, false);
        const isUnavailable = !matchingAvailableVariant;

        btn.disabled = isUnavailable;
        btn.classList.toggle("unavailable", isUnavailable);
        btn.classList.toggle("is-disabled", isUnavailable);
        btn.setAttribute("aria-disabled", String(isUnavailable));

        if (isUnavailable && btn.classList.contains("active")) {
          btn.classList.remove("active");
          btn.setAttribute("aria-pressed", "false");
        }
      });
    });
  }

  function updateState() {
    const state = getSelectedState();

    groups.forEach((group) => {
      renderPreview(group, state);
    });

    if (!selectionIsComplete(state)) {
      hiddenInput.value = "";
      addToCartBtn.disabled = true;
      setPriceHTML(null);
      setCartVisibility(
        false,
        hintEl?.dataset.defaultText || window.themeStrings?.selection_required || ""
      );
      return;
    }

    const variant = findMatchingVariant(state, false, true);

    if (variant && variant.available) {
      hiddenInput.value = variant.id;
      addToCartBtn.disabled = false;
      setPriceHTML(variant);
      setCartVisibility(true);

      if (variant.featured_image) {
        swapMainSrc(variant.featured_image);
      }
    } else {
      hiddenInput.value = "";
      addToCartBtn.disabled = true;
      setPriceHTML(variant || null);
      setCartVisibility(
        false,
        window.themeStrings?.unavailable || hintEl?.dataset.defaultText || "",
        "warning"
      );
    }
  }

  function updateAll() {
    updateButtonAvailability();
    updateState();
  }

  groups.forEach((group) => {
    group.buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.disabled) return;

        group.buttons.forEach((b) => {
          b.classList.remove("active");
          b.setAttribute("aria-pressed", "false");
        });

        btn.classList.add("active");
        btn.setAttribute("aria-pressed", "true");

        updateAll();
      });
    });
  });

  updateAll();

  /* =================
     SHIPPING ACCORDION
  ================= */
  const toggle = document.querySelector(".shipping-toggle");
  const content = document.getElementById("shipping-content");

  if (toggle && content) {
    toggle.addEventListener("click", () => {
      const open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!open));
      content.classList.toggle("open", !open);
    });
  }

  /* =================
     MORE INFO BUTTONS
  ================= */
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".variant-more-info-btn");
    if (!btn) return;

    const key = btn.dataset.info;
    const target = document.querySelector(`.variant-more-info-content[data-info-target="${key}"]`);
    if (!target) return;

    const isOpen = target.classList.contains("open");

    document
      .querySelectorAll(".variant-more-info-content")
      .forEach((section) => section.classList.remove("open"));

    document
      .querySelectorAll(".variant-more-info-btn")
      .forEach((button) => {
        if (window.themeStrings?.more_info) {
          button.textContent = window.themeStrings.more_info;
        }
        button.setAttribute("aria-expanded", "false");
      });

    if (!isOpen) {
      target.classList.add("open");
      if (window.themeStrings?.hide_info) {
        btn.textContent = window.themeStrings.hide_info;
      }
      btn.setAttribute("aria-expanded", "true");
    }
  });
});